import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import dateFormat from "dateformat";
import React from "react";
import { useSelector } from "react-redux";
import Icons from "../../../../resources/icons/Icons";
import {
  convertCurrencyToSymbol,
  getSiteIconName
} from "../../../../utils/CommonUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import SharePopover from "../../Popovers/SharePopover/SharePopover";
import classes from "./ParkingHistoryCard.module.css";
import { LENGTHS } from "../../../../config/Config";

const ParkingHistoryCard = (props) => {
  const parkingSite = useSelector((state) =>
    state.user.sites.find((site) => {
      return site.id === props.parkingHistory.siteId;
    })
  );
  const invoiceSummary = props.utronUser?.invoiceSummaries?.find(
    (invoiceSummary) =>
      invoiceSummary?.parkingHistoryId === props.parkingHistory?.id
  );

  const isChecked = Boolean(
    invoiceSummary && props.checkedList[invoiceSummary.parkingHistoryId]
  );

  const handleCheck = (event) => {
    props.handleCheck(event.target.value);
  };

  return (
    <div className={classes.cardContainer}>
      <div className={classes.cardContent}>
        <CustomIcon
          className={classes.siteIcon}
          iconName={getSiteIconName(parkingSite?.clientId)}
        />
        <div className={classes.cardInfo}>
          <span className={classes.siteName}>{parkingSite?.displayName}</span>
          <span className={classes.siteAddress}>
            {dateFormat(props.parkingHistory.entranceDate, "d, mmmm, yyyy")}
          </span>
        </div>
      </div>
      {!props.isHover && invoiceSummary ? (
        <span className={classes.price}>
          {`${convertCurrencyToSymbol(invoiceSummary.currency)}${invoiceSummary.finalPrice > 0 && parseFloat(invoiceSummary.finalPrice.toFixed(LENGTHS.TO_FIXED_LENGTH))}`}
        </span>
      ) :
        <span className={classes.price}>
          {props.parkingHistory?.retrievalDate === null ? "" : invoiceSummary?.finalPrice > 0 ? "" : `${convertCurrencyToSymbol(parkingSite?.billingCurrency)}0`}
        </span>
      }
      {props.isHover && invoiceSummary && (
        <div className={classes.multiSelection}>

          <SharePopover siteName={parkingSite?.displayName} userName={`${props.utronUser?.firstName} ${props.utronUser?.lastName}`} getSelectedValues={props.getSelectedValues} parkingHistoryId={invoiceSummary.parkingHistoryId}>
            <img className={classes.shareIcon} src={Icons.SHARE} alt="Share Icon"></img>
          </SharePopover>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleCheck}
                  checked={isChecked}
                  value={invoiceSummary.parkingHistoryId}
                  icon={
                    <RadioButtonUncheckedIcon
                      className={classes.checkboxIcon}
                    />
                  }
                  checkedIcon={
                    <RadioButtonCheckedIcon className={classes.checkboxIcon} />
                  }
                />
              }
              label=""
            />
          </FormGroup>
        </div>
      )}
    </div>
  );
};

export default ParkingHistoryCard;
